module.exports = __webpack_public_path__ + "static/media/pdf.2d1bad4c.png";